import React, { Fragment } from "react";
// import PropTypes from "prop-types";
import { Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import { COURSE_STATUS } from "@constants";
// import styles from "./styles/ButtonManageCourse.module.css";

const ButtonManageCourse = (props) => {
  const { status, onChangeStatus } = props;
  // state

  // variables
  let statusName;
  let statusVariant;
  switch (status) {
    case 0:
      statusName = "Pending";
      statusVariant = "primary";
      break;
    case 1:
      statusName = "Approved";
      statusVariant = "success";
      break;
    case 2:
      statusName = "Rejected";
      statusVariant = "warning";
      break;
    case 3:
      statusName = "Blocked";
      statusVariant = "danger";
      break;
  }

  // logics before hooks

  // hooks
  const { courseStatusChanger } = useSelector((state) => state.course);
  //   spinnerVisible = courseStatusChanger.processing;

  // logics

  // UI partials

  // effects

  // render
  return (
    <div>
      <strong className={`text-${statusVariant} mr-2`}>({statusName})</strong>
      <div className="d-flex gap-2 mt-2">
        {status === 0 ? (
          <Fragment>
            <Button
              disabled={courseStatusChanger.processing}
              variant="success"
              onClick={() => onChangeStatus(COURSE_STATUS.APPROVE)}
            >
              Approve
            </Button>
            <Button
              disabled={courseStatusChanger.processing}
              variant="primary"
              onClick={() => onChangeStatus(COURSE_STATUS.REJECT)}
            >
              Reject
            </Button>
          </Fragment>
        ) : null}
        {status === 1 ? (
          <Fragment>
            <Button
              disabled={courseStatusChanger.processing}
              variant="primary"
              onClick={() => onChangeStatus(COURSE_STATUS.BLOCK)}
            >
              Block
            </Button>
            <Button
              disabled={courseStatusChanger.processing}
              variant="primary"
              onClick={() => onChangeStatus(COURSE_STATUS.REJECT)}
            >
              Reject
            </Button>
          </Fragment>
        ) : null}
        {status === 2 ? (
          <Button
            disabled={courseStatusChanger.processing}
            variant="success"
            onClick={() => onChangeStatus(COURSE_STATUS.APPROVE)}
          >
            Approve
          </Button>
        ) : null}
        {status === 3 ? (
          <Button
            disabled={courseStatusChanger.processing}
            variant="success"
            onClick={() => onChangeStatus(COURSE_STATUS.APPROVE)}
          >
            Unblock
          </Button>
        ) : null}
      </div>
    </div>
  );
};

/* required: display name */
ButtonManageCourse.displayName = "ButtonManageCourse";

/* required: props types */
ButtonManageCourse.propTypes = {};

/* required: default props */
ButtonManageCourse.defaultProps = {};

export { ButtonManageCourse };
